<template>
  <div class="flex flex-col min-h-0 pb-2 h-full">
    <div class="px-4 pt-3 pb-2 shrink-0">
      <div class="bg-gray-100 flex items-center p-0.5 rounded-[4px]">
        <button
          v-for="subTab in subTabs"
          :key="subTab.key"
          class="flex-1 text-sm text-gray-600 border rounded-[4px] px-3 py-2 transition-all"
          :class="{
            'bg-white border-gray-200': activeSubTab === subTab.key,
            'border-transparent': activeSubTab !== subTab.key,
            'cursor-pointer': subTab.enabled,
            'cursor-not-allowed': !subTab.enabled,
          }"
          :disabled="!subTab.enabled"
          @click="onClick(subTab)"
        >
          {{ subTab.label }}
        </button>
      </div>
    </div>

    <component
      :is="activeSubTab"
      @openModal="$emit('openModal')"
      @closeModal="$emit('closeModal')"
    />
  </div>
</template>

<script>
import ConversationTab from './ConversationTab.vue';
import ContactTab from './ContactTab.vue';
import TicketTab from './TicketTab.vue';

export default {
  name: 'ConversationCustomAttributes',
  components: {
    conversation: ConversationTab,
    contact: ContactTab,
    ticket: TicketTab,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeSubTab: 'conversation',
    };
  },
  computed: {
    ticket() {
      return this.$store.getters['tickets/getCurrentTicket'];
    },
    subTabs() {
      return [
        {
          key: 'conversation',
          label: this.$t('CONTACT_PANEL.TABS.SUB.CONVERSATION'),
          enabled: true,
        },
        {
          key: 'contact',
          label: this.$t('CONTACT_PANEL.TABS.SUB.CONTACT'),
          enabled: true,
        },
        {
          key: 'ticket',
          label: this.$t('CONTACT_PANEL.TABS.SUB.TICKET'),
          enabled: this.ticket?.id,
        },
      ];
    },
  },
  methods: {
    onClick(subTab) {
      if (subTab.enabled) this.activeSubTab = subTab.key;
    },
  },
};
</script>
